import { render, staticRenderFns } from "./DatasetUpload.vue?vue&type=template&id=7ddff1a4&scoped=true&"
import script from "./DatasetUpload.vue?vue&type=script&lang=js&"
export * from "./DatasetUpload.vue?vue&type=script&lang=js&"
import style0 from "./DatasetUpload.vue?vue&type=style&index=0&id=7ddff1a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddff1a4",
  null
  
)

export default component.exports